import styled, { css } from 'styled-components';
// import { WRAPPER } from '@/shared/styles/themes';
import { Image as NextImage } from '@/shared/ui/image/Image';
import { Button } from '@/shared/ui/form/button';
import { BodyTextMediumD, BodyTextMediumB } from '@/shared/ui/typography2';

export const WalletIcon = styled(NextImage)`
  cursor: pointer;

  & img {
    display: flex;
  }
`;

export const AvatarIcon = styled(NextImage)`
  & img {
    display: flex;
  }
`;

export const GuestActions = styled.div`
  display: flex;
  gap: 8px;

  && [data-analytics-id='auth_sign_up_button'],
  && [data-analytics-id='auth_sign_in_button'] {
    padding: 0 32px;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export const LanguageSlot = styled.div`
  min-width: 88px;
`;

export const AuthorizedRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
`;

export const AuthorizedActions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;

  @media (max-width: 768px) {
    gap: 8px;
  }
`;

export const BalanceColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const GameBonusWarningSlot = styled.div`
  display: contents;

  @media (orientation: portrait) {
    display: none;
  }
`;

export const ProfileButtonSlot = styled.div`
  position: relative;
  flex: auto;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const HeaderButton = styled(Button)<{
  $isEmptyBalance: boolean;
  $isViewImg?: boolean;
}>`
  display: flex;
  flex-direction: column;
  flex: auto;
  width: max-content;
  min-height: 40px;
  height: 40px;
  padding: 0 2px;

  ${({ $isEmptyBalance }) =>
    $isEmptyBalance &&
    `background: linear-gradient(90deg, #FF9500 0%, #FF5E00 100%);`}

  & img {
    @media (max-width: 260px) {
      display: none !important;
    }

    @media (max-width: 375px) {
      ${({ $isViewImg }) => $isViewImg && `display: none !important;`}
    }
  }
`;

export const FullscreenButton = styled.button`
  display: flex;
  width: 40px;
  height: 40px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 8px;
  background: #3d3c41;
`;

export const FullScreenImage = styled.div`
  display: flex;
  width: 24px;
  height: 24px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  background-image: url('/images/icons/jackpot/full-screen.svg');
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;

const commonTextStyle = css`
  max-width: 110px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 100%;
`;

export const BodyTextMediumBModern = styled(BodyTextMediumB)`
  ${commonTextStyle}
`;

export const BodyTextMediumDModern = styled(BodyTextMediumD)`
  ${commonTextStyle}
  max-width: 100px;
`;
